__turbopack_context__.v({
  "buttonContainer": "styles-module__z7Duja__buttonContainer",
  "content": "styles-module__z7Duja__content",
  "description": "styles-module__z7Duja__description",
  "header": "styles-module__z7Duja__header",
  "logo": "styles-module__z7Duja__logo",
});
